import moment from 'moment';
import { API_DATE_FORMAT } from '@ubeya/shared/constants';

const rangesOverlap = (aStart, aEnd, bStart, bEnd) => aStart < bEnd && bStart < aEnd;

export const buildMainProjectBarLines = (mainProjects, weekDays) => {
  const validWeekDays = (weekDays || []).filter(Boolean);
  if (!validWeekDays.length || !mainProjects?.length) {
    return [];
  }

  // Use indices from the full week row (incl. leading/trailing padding cells), same as WeeklyPlannerBar
  const dateToColumnMap = {};
  (weekDays || []).forEach((day, index) => {
    if (day) {
      dateToColumnMap[moment(day).format(API_DATE_FORMAT)] = index + 1;
    }
  });

  const weekStart = moment(validWeekDays[0]);
  const weekEnd = moment(validWeekDays[validWeekDays.length - 1]);

  const mainProjectMap = new Map();
  mainProjects.forEach((mainProject) => {
    if (!mainProjectMap.has(mainProject.id)) {
      mainProjectMap.set(mainProject.id, mainProject);
    }
  });

  const lines = [];
  mainProjectMap.forEach((mainProject) => {
    const mainProjectStart = moment(mainProject.startDate);
    const mainProjectEnd = moment(mainProject.endDate || mainProject.startDate);

    const effectiveStart = moment.max(mainProjectStart, weekStart);
    const effectiveEnd = moment.min(mainProjectEnd, weekEnd);

    if (effectiveStart.isAfter(effectiveEnd)) {
      return;
    }

    const startCol = dateToColumnMap[effectiveStart.format(API_DATE_FORMAT)];
    if (startCol == null) {
      return;
    }
    const endCol = (dateToColumnMap[effectiveEnd.format(API_DATE_FORMAT)] ?? startCol) + 1;

    lines.push({
      id: mainProject.id,
      name: mainProject.name,
      startCol,
      endCol,
      clickedDate: effectiveStart.format(API_DATE_FORMAT),
      mainProject
    });
  });

  return lines;
};

export const packMainProjectBarLinesIntoTracks = (lines) => {
  if (!lines.length) {
    return [];
  }
  const sorted = [...lines].sort((a, b) => {
    if (a.startCol !== b.startCol) {
      return a.startCol - b.startCol;
    }
    return b.endCol - a.endCol;
  });

  const tracks = [];
  for (const line of sorted) {
    let row = 0;
    while (
      row < tracks.length &&
      tracks[row].some((placed) => rangesOverlap(placed.startCol, placed.endCol, line.startCol, line.endCol))
    ) {
      row += 1;
    }
    if (!tracks[row]) {
      tracks[row] = [];
    }
    tracks[row].push(line);
  }
  return tracks;
};

export const getMainProjectBarTrackCount = (mainProjects, weekDays) =>
  packMainProjectBarLinesIntoTracks(buildMainProjectBarLines(mainProjects, weekDays)).length;
